import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M13 7.83L16.59 11.41L18 10L12 4L6 10L7.41 11.41L11 7.83V20H13V7.83Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ShortUp"
);
